import { InfoOutlined } from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";
import { SourceDataRecordsApiResponse } from "./DatasetViewer";
import { Dataset } from "../types";
import { isDocumentDatasetType } from "../services/DatasetServices";

type DatasetInfoItemsProps = {
  dataset: Dataset;
  sourceDataRecords: SourceDataRecordsApiResponse | undefined;
};

const DatasetInfoItems = ({
  dataset,
  sourceDataRecords,
}: DatasetInfoItemsProps) => {
  const sourceLabels = (sourceDataRecords?.meta?.sourceProviders ?? []).map(
    ({ label }) => label,
  );
  const source = sourceLabels.length
    ? `${sourceLabels.length > 1 ? "Sources" : "Source"}: ${sourceLabels.join(", ")}`
    : "";
  const datasetCreateUser = dataset?.create_user?.user_display_name
    ? `Created by ${dataset?.create_user?.user_display_name}`
    : "";
  const creationDate = dataset?.create_date
    ? `Created on ${new Date(dataset.create_date).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })}`
    : "";
  const totalRowCount = sourceDataRecords?.meta?.totalRowCount;
  const isEstimate = sourceDataRecords?.meta?.totalRowCountIsEstimate;
  const totalRevisionCount = sourceDataRecords?.meta?.totalRevisionCount;
  const isDocumentDataset = isDocumentDatasetType(dataset?.dataset_type?.id);

  const countText = totalRowCount
    ? `${totalRowCount.toLocaleString()}${isEstimate ? "+" : ""} ${
        isDocumentDataset ? "documents" : "rows"
      }`
    : "";
  const showsRevisionTotal =
    isDocumentDataset &&
    typeof totalRowCount === "number" &&
    typeof totalRevisionCount === "number" &&
    totalRevisionCount > totalRowCount;

  const count =
    countText && showsRevisionTotal ? (
      <Tooltip
        title={`${totalRevisionCount.toLocaleString()} documents, including all revisions`}
      >
        <Box
          component="span"
          data-testid="dataset-document-count"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.25,
            cursor: "help",
          }}
        >
          {countText}
          <InfoOutlined sx={{ fontSize: 14 }} />
        </Box>
      </Tooltip>
    ) : (
      countText
    );
  const rest = [source, datasetCreateUser, creationDate]
    .filter(Boolean)
    .join(" - ");

  return (
    <Typography variant="body2" color="text.secondary">
      {count}
      {countText && rest && " - "}
      {rest}
    </Typography>
  );
};

export default DatasetInfoItems;
